import { getAuth, signInWithPhoneNumber } from "firebase/auth";
import { doc, updateDoc } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { useEffect, useRef, useState } from "react";
import {
  AuthErrorMessages,
  ToastInfoMessages,
  ToastSuccessMessages,
} from "../../../controllers/auth/AuthErrorMessages";
import GetClient from "../../../controllers/auth/GetClient";
import GetUser from "../../../controllers/auth/GetUser";
import UpdateClient from "../../../controllers/auth/UpdateClient";
import { getLocalStorageItem } from "../../../controllers/localStorage/getLocalStorage";
import { db, functions } from "../../../firebase";

export default function useProfile() {
  let auth = getAuth();
  const [Phone, setPhone] = useState("");
  const [CodeSent, setCodeSent] = useState(false);
  const [CurrentAuth, setCurrentAuth] = useState();
  const [User, setUser] = useState(null);
  const [Client, setClient] = useState(null);
  const ProfileImage = useRef("").current;
  const BusinessLogo = useRef("").current;
  // useEffect(async () => {
  //   getAuth().onAuthStateChanged(async () => {
  //     const user = getAuth().currentUser;
  //     setCurrentAuth(user);
  //   });
  // }, []);

  useEffect(async () => {
    getAuth().onAuthStateChanged(async () => {
      const user = await GetUser(getAuth().currentUser.uid);
      setCurrentAuth(user);
    });
  }, []);

  const handleProfileImageChange = (e) => {
    // const uploadImages = async () => {
    //   setIsImageUploading(true);
    //   getAuth().onAuthStateChanged(async () => {
    //     const __ext = InputImage.name.split(".").pop();
    //     const id = getAuth().currentUser.uid;
    //     const __path = ref(
    //       getStorage(),
    //       `profile_images/${id}/original.${__ext}`
    //     );
    //     await uploadBytes(__path, InputImage).then(async (snapshot) => {
    //       listImages();
    //     });
    //   });
    // };
    //   useEffect(() => {
    //     uploadImages();
    //   }, [InputImage]);
  };

  const handleBusinessLogoChange = (e) => {};

  const triggerUpdateProfile = async (e) => {
    const { businessName } = e;
    // update user document
    await UpdateClient(getLocalStorageItem("bid"), {
      businessName,
    });
    // update client document
  };

  const getProfile = async () => {
    getAuth().onAuthStateChanged(async () => {
      let user = await GetUser(getAuth().currentUser.uid);
      const client = await GetClient(getLocalStorageItem("bid"));

      if (!user.verified_email) {
        user.email = "";
      }

      setUser(user);
      setClient(client);
    });
  };

  const updateProfile = async (data) => {
    // {
    //   businessName: "Logic Associates"
    //   confirmPassword: "adadadad"
    //   email: "adilzubari852@gmail.com"
    //   name: "Muhammad Adil"
    //   password: "adadadad"
    //   phone: undefined
    // }
    const {
      businessName,
      email,
      name,
      businessContactNumber,
      password,
      phone,
    } = data;

    /* Updating User Profile */
    let updatedUser;
    if (email === undefined)
      updatedUser = {
        name,
        businessName,
      };
    // else if (email === undefined || phone === undefined) {
    //   updatedUser = {
    //     name,
    //     businessName,
    //     verification_email_sent: false,
    //   };
    // } else
    else {
      updatedUser = {
        name,
        email,
        businessName,
        verification_email_sent: false,
      };
    }

    const userDoc = await doc(db, "users", getAuth().currentUser.uid);
    await updateDoc(userDoc, updatedUser);

    const updateUserName = httpsCallable(functions, "updateUserName");
    const re = await updateUserName({
      uid: getAuth().currentUser.uid,
      name,
    });

    /* Updating Business Profile */
    await updateDoc(doc(db, "clients", getLocalStorageItem("bid")), {
      businessName,
      businessContactNumber,
    });
  };

  const resendEmail = async () => {
    const userDoc = await doc(db, "users", getAuth().currentUser.uid);
    await updateDoc(userDoc, { verification_email_sent: false });
    ToastSuccessMessages("email/resend-successful");
  };

  useEffect(() => getProfile(), []);

  const VerifyPhoneNumber = async () => {
    return await signInWithPhoneNumber(auth, Phone, window.recaptchaVerifier)
      .then((confirmationResult) => {
        window.confirmationResult = confirmationResult;
        // setCodeSent(true);
        ToastInfoMessages("phone/code-resend-successfully");
        return true;
      })
      .catch((error) => {
        console.log(error);
        // AuthErrorMessages("auth/captcha-expired");
        return true;
      });
  };

  return [
    User,
    Client,
    CurrentAuth,
    ProfileImage,
    BusinessLogo,
    triggerUpdateProfile,
    handleProfileImageChange,
    handleBusinessLogoChange,
    updateProfile,
    resendEmail,
    VerifyPhoneNumber,
    setPhone,
    Phone,
  ];
}
